import React from 'react'

import { Col, Row, Form, Portlet, Button } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as SaldosInicialesCrud from 'services/saldosIniciales.service'

import DetallesSection from './detallesSection'

const portletBreadcrumbs = [
  { name: 'Saldos Iniciales', path: `/${CodigosTransaccionesConstant.SALDOSINICIALES_LISTA}` },
  { name: 'Editar Por Grupo' }
]

const EdicionPorGrupo = () => {
  const [busqueda, setBusqueda] = React.useState('')

  const [registros, setRegistros] = React.useState(null)

  const idSectionRef = React.useRef(1)

  const changeBusquedaHandler = React.useCallback(e => {
    setBusqueda(e.target.value)
    setRegistros(null)
  }, [])

  const clickBuscarHandler = React.useCallback(() => {
    SaldosInicialesCrud.getSaldoInicial_SoloDetalles(busqueda).then(({ data }) => {
      idSectionRef.current = idSectionRef.current + 1
      const nuevosDetalles = data.map((x, k) => {
        return {
          ...x,
          _idFila: k,
          __filaActiva: false,
          __focusCantidad: false,
          __focusPrecio: false,
          cantidad: `${x.cantidad}`,
          precio: `${x.precio}`,
          nombreUnidadDeMedida: x.unidadMedida,
          subTotal: `${x.cantidad * x.precio}`
        }
      })
      setRegistros(nuevosDetalles)
    })
  }, [busqueda])

  const successSubmitHandler = React.useCallback(() => {
    idSectionRef.current = idSectionRef.current + 1
    setRegistros(null)
    setBusqueda('')
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Saldos Iniciales' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row>
            <Col md={4}>
              <Form.Group>
                <Form.Label text='BUSQUEDA' htmlFor='input-titulo' md={4} />
                <Col md={8}>
                  <Form.InputText
                    autoComplete='off'
                    name='input-busqueda'
                    id='input-busqueda'
                    value={busqueda}
                    onChange={changeBusquedaHandler}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Button onClick={clickBuscarHandler} type='submit'>
                Buscar
              </Button>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>

      {registros && (
        <DetallesSection key={idSectionRef.current} registros={registros} successSubmitHandler={successSubmitHandler} />
      )}
    </>
  )
}

export default EdicionPorGrupo
